import React, { Component } from "react";
import PaymentService from "../services/payment.service";
import EventBus from "../common/EventBus";
import AuthService from "../services/auth.service";
import DatatableComponent from "../extra/datatable";
import authService from "../services/auth.service";
import loading from "../img/loading.gif";
export default class Payment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: "",
      redirect: ""
    };
  }
  add(){
    localStorage.setItem("page","create_payment");
    window.location.replace("/create_payment");
  }
  componentDidMount() {

    const currentUser = AuthService.getCurrentUser();
    if (!currentUser || (currentUser.roles[0]!=="ROLE_ADMIN" && currentUser.roles[0]!=="ROLE_SUPER_AGENT")) {
      authService.logout();
    }
    this.setState({ currentUser: currentUser, userReady: true })

    PaymentService.getAllPayments(currentUser.service).then(
      response => {
        this.setState({
          content: response.data['hydra:member']
        });
      },
      error => {
        this.setState({
          content:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString()
        });

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  }

  render() {

    let items  = [];
    if(this.state.content){
      items = this.state.content;
    }
    return (
      <><div className="col-md-12">
        <header className="jumbotron">
          <h3>
            <strong>Liste des paiements</strong>
          </h3>
          <div>
            <button onClick={this.add} className=" btn-ohm btn btn-primary">Créer un paiement</button>
          </div>
        </header>
        <div className="App">
          {this.state.message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {this.state.message}
              </div>
            </div>
          )}
           {
                       items && items.length > 0 ? (
                              <div className="col-md-12 bg-white jumbotron rounded p-10 mt-5">
                              <DatatableComponent items={items}
                                  updateAction={''}
                                  deleteAction={''}
                                  _tableType='payment'/>
                          </div>
                        ) : (
                        <div className='col-md-12 bg-white rounded p-10 mt-5'>
                          <img className="loading" alt={"loading"} height={80} src={loading}/>
                        </div>
                       )
                       } 

        </div>
        
        </div>
        
      </>
    );
  }
}
